import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { SettingsAssignmentCreateStrategyRoute } from 'borrower/routes/settings/SettingsAssignmentCreateStrategyRoute';
import { SettingsAssignmentEditStrategyRoute } from 'borrower/routes/settings/SettingsAssignmentEditStrategyRoute';
import { SettingsAssignmentStrategyRoute } from 'borrower/routes/settings/SettingsAssignmentStrategyRoute';
import { SettingsBankAccountsRoute } from 'borrower/routes/settings/SettingsBankAccountsRoute';
import { SettingsBankIntegrationsRoute } from 'borrower/routes/settings/SettingsBankIntegrationsRoute';
import { SettingsNotificationsRoute } from 'borrower/routes/settings/SettingsNotificationsRoute';
import { SettingsUserRoute } from 'borrower/routes/settings/SettingsUserRoute';
import { SettingsWebhookRoute } from 'borrower/routes/settings/SettingsWebhookRoute';
import { LatestAssignmentPipelineRunMetadataForLpGroupingProvider } from 'packages/loanProduct/hooks/LatestAssignmentPipelineRunMetadataForLpGroupingProvider';
import { LoanProductCreditFacilityGroupProvider } from 'packages/loanProduct/hooks/LoanProductCreditFacilityGroupingProvider';

export const SettingsRouter = () => {
  const { data, loading } = useGetUserQuery();

  if (loading || !data || !data.user) {
    return <Skeleton />;
  }

  const { organizationId } = data.user;
  return (
    <LoanProductCreditFacilityGroupProvider
      organizationId={organizationId}
      renderLoading={<Skeleton />}
      fallbackComponent={<Skeleton />}
    >
      <LatestAssignmentPipelineRunMetadataForLpGroupingProvider
        renderLoading={<Skeleton />}
      >
        <Switch>
          <Route exact path="/settings/user" component={SettingsUserRoute} />
          <Route
            exact
            path="/settings/integrations"
            component={SettingsUserRoute}
          />
          <Route
            exact
            path="/settings/bank-accounts"
            component={SettingsBankAccountsRoute}
          />
          <Route
            exact
            path="/settings/bank-integrations"
            component={SettingsBankIntegrationsRoute}
          />
          <Route
            exact
            path="/settings/notifications"
            component={SettingsNotificationsRoute}
          />
          <Route
            exact
            path="/settings/webhooks"
            component={SettingsWebhookRoute}
          />
          <Route
            exact
            path="/settings/assignment-strategy"
            component={SettingsAssignmentStrategyRoute}
          />
          <Route
            exact
            path="/settings/assignment-strategy/new"
            component={SettingsAssignmentCreateStrategyRoute}
          />
          <Route
            exact
            path="/settings/assignment-strategy/:strategyId/edit"
            component={SettingsAssignmentEditStrategyRoute}
          />

          <Route exact path="/settings">
            <Redirect from="/settings" to="/settings/user" />
          </Route>
          <Route
            exact
            path="/slack/oauth_redirect"
            component={SettingsUserRoute}
          />
        </Switch>
      </LatestAssignmentPipelineRunMetadataForLpGroupingProvider>
    </LoanProductCreditFacilityGroupProvider>
  );
};
